
const composite = [
  { label: 'Composite', value: 40 }
];

const extraction = [
  { label: 'Extraction', value: 80 }
];

const finance = [
  { label: 'Finance', value: 20 }
];

const environment = [
  { label: 'Environment', value: 50 }
];

const countriesRankData = [
  { name: 'Pepi', score: 96 },
  { name: 'Pepi', score: 94 },
  { name: 'Pepi', score: 94 },
  { name: 'Pepi', score: 90 },
  { name: 'Pepi', score: 87 },
  { name: 'Pepi', score: 87 },
  { name: 'Pepi', score: 85 },
  { name: 'Pepi', score: 84 },
  { name: 'Mas', score: 74 },
  { name: 'Mas', score: 70 },
  { name: 'Mas', score: 69 },
  { name: 'Mas', score: 69 },
  { name: 'Mas', score: 68 },
  { name: 'Mas', score: 68 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Mas', score: 67 },
  { name: 'Tunisia', score: 65 },
  { name: 'asdfggg', score: 64 },
  { name: 'asdfggg', score: 63 },
  { name: 'asdfggg', score: 62 },
  { name: 'asdfggg', score: 61 },
  { name: 'asdfggg', score: 60 },
  { name: 'asdfggg', score: 59 },
  { name: 'asdfggg', score: 59 },
  { name: 'asdfggg', score: 59 },
  { name: 'asdfggg', score: 58 },
  { name: 'asdfggg', score: 58 },
  { name: 'asdfggg', score: 58 },
  { name: 'asdfggg', score: 58 },
  { name: 'asdfggg', score: 57 },
  { name: 'asdfggg', score: 57 },
  { name: 'asdfggg', score: 55 },
  { name: 'asdfggg', score: 55 },
  { name: 'asdfggg', score: 55 },
  { name: 'asdfggg', score: 55 },
  { name: 'asdfggg', score: 54 },
  { name: 'asdfggg', score: 54 },
  { name: 'asdfggg', score: 52 },
  { name: 'asdfggg', score: 51 },
  { name: 'asdfggg', score: 50 },
  { name: 'asdfggg', score: 50 },
  { name: 'asdfggg', score: 48 },
  { name: 'asdfggg', score: 48 },
  { name: 'asdfggg', score: 46 },
  { name: 'asdfggg', score: 46 },
  { name: 'asdfggg', score: 44 },
  { name: 'asdfggg', score: 44 },
  { name: 'asdfggg', score: 44 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 43 },
  { name: 'asdfggg', score: 41 },
  { name: 'asdfggg', score: 41 },
  { name: 'adf', score: 37 },
  { name: 'adf', score: 37 },
  { name: 'adf', score: 37 },
  { name: 'adf', score: 36 },
  { name: 'adf', score: 36 },
  { name: 'adf', score: 35 },
  { name: 'adf', score: 35 },
  { name: 'adf', score: 33 },
  { name: 'adf', score: 32 },
  { name: 'adf', score: 32 },
  { name: 'sdfgs', score: 30 },
  { name: 'sdfgs', score: 28 },
  { name: 'sdfgs', score: 28 },
  { name: 'sdfgs', score: 26 },
  { name: 'sdfgs', score: 25 },
  { name: 'sdfgs', score: 25 },
  { name: 'sdfgs', score: 23 },
  { name: 'sdfgs', score: 23 },
  { name: 'sdfgs', score: 22 },
  { name: 'sdfgs', score: 22 },
  { name: 'asdf', score: 18 },
  { name: 'asdf', score: 15 },
  { name: 'asdf', score: 15 },
  { name: 'asdf', score: 13 },
  { name: 'asdf', score: 12 },
  { name: 'asdf', score: 12 },
  { name: 'asdf', score: 8 }
];

const rgi1 = [
  { score: 55, name: 'Value extraction', avg: 20 },
  { score: 23, name: 'Licensing', avg: 38 },
  { score: 67, name: 'Taxation', avg: 68 },
  { score: 34, name: 'Local impact', avg: 87 }
];

const rgi2 = [
  { score: 55, name: 'Public finance managment', avg: 20 },
  { score: 34, name: 'State-owned enterprises', avg: 87 },
  { score: 23, name: 'Sovereign wealth funds', avg: 38 },
  { score: 67, name: 'Revenue sharing', avg: 68 }
];

const rgi3 = [
  { score: 55, name: 'Enabling Environment', avg: 20 },
  { score: 23, name: 'Accountability and participation', avg: 38 },
  { score: 67, name: 'Government effectiveness', avg: 68 },
  { score: 34, name: 'Rule of law', avg: 87 },
  { score: 55, name: 'Private sector space', avg: 20 },
  { score: 34, name: 'Control of corruption', avg: 87 },
  { score: 23, name: 'Political stability', avg: 38 },
  { score: 67, name: 'Open data inventory', avg: 68 }
];

const compare1 = [
  { value1: 12, value2: 46, name: 'Composite' }
];

const compare2 = [
  { value1: 33, value2: 22, name: 'Value extraction' },
  { value1: 76, value2: 51, name: 'Licensing' },
  { value1: 88, value2: 43, name: 'Taxation' },
  { value1: 21, value2: 90, name: 'Local impact' }
];

const compare3 = [
  { value1: 55, value2: 30, name: 'Public finance managment' },
  { value1: 15, value2: 5, name: 'State-owned enterprises' },
  { value1: 67, value2: 76, name: 'Revenue sharing' },
  { value1: 34, value2: 88, name: 'Sovereign wealth funds' }
];

const graph1 = [
  { label: 'Law', value: 89 },
  { label: 'Practice', value: 70 }
];

const graph2 = [
  { label: 'Colombia', score: 89, barrels: 1500000, population: 39.5 },
  { label: 'Mexico', score: 33, barrels: 3500000, population: 161.3 },
  { label: 'Bolivia', score: 54, barrels: 500000, population: 0.85 },
  { label: 'China', score: 22, barrels: 4000000, population: 1371.32 }
];

const MAP_COUNTRY_FILLS = {
  // single-sectors
  failing: '#a3282f',
  weak: '#f98c42',
  partial: '#fff08c',
  satisfactory: '#c0ee9f',
  good: '#71e27c',
  'failing-v1': '#c2ddec',
  'weak-v1': '#c2ddec',
  'partial-v1': '#c2ddec',
  'satisfactory-v1': '#c2ddec',
  'good-v1': '#c2ddec',

  // dual-sectors
  'diagonal-good-satisfactory': 'url(#diagonal-good-satisfactory)',
  'diagonal-good-partial': 'url(#diagonal-good-partial)',
  'diagonal-good-weak': 'url(#diagonal-good-weak)',
  'diagonal-good-failing': 'url(#diagonal-good-failing)',

  'diagonal-satisfactory-good': 'url(#diagonal-satisfactory-good)',
  'diagonal-satisfactory-partial': 'url(#diagonal-satisfactory-partial)',
  'diagonal-satisfactory-weak': 'url(#diagonal-satisfactory-weak)',
  'diagonal-satisfactory-failing': 'url(#diagonal-satisfactory-failing)',

  'diagonal-partial-good': 'url(#diagonal-partial-good)',
  'diagonal-partial-satisfactory': 'url(#diagonal-partial-satisfactory)',
  'diagonal-partial-weak': 'url(#diagonal-partial-weak)',
  'diagonal-partial-failing': 'url(#diagonal-partial-failing)',

  'diagonal-weak-good': 'url(#diagonal-weak-good)',
  'diagonal-weak-satisfactory': 'url(#diagonal-weak-satisfactory)',
  'diagonal-weak-partial': 'url(#diagonal-weak-partial)',
  'diagonal-weak-failing': 'url(#diagonal-weak-failing)',

  'diagonal-failing-good': 'url(#diagonal-failing-good)',
  'diagonal-failing-satisfactory': 'url(#diagonal-failing-satisfactory)',
  'diagonal-failing-partial': 'url(#diagonal-failing-partial)',
  'diagonal-failing-weak': 'url(#diagonal-failing-weak)',

  'diagonal-equal-satisfactory': 'url(#diagonal-equal-satisfactory)',
  'diagonal-equal-partial': 'url(#diagonal-equal-partial)',
  'diagonal-equal-weak': 'url(#diagonal-equal-weak)',
  'diagonal-equal-good': 'url(#diagonal-equal-good)',

  defaultFill: '#fff'
};

// Graph types names
const GAP = 'Performance gap between law and practice';
const TABLE = 'Direction of travel on key resource governance questions between 2012 and 2016';
const BUBBLES = 'Population, resource dependence and governance';

const GRAPH_TYPES = {
  arc: GAP,
  table: TABLE,
  bubbles: BUBBLES
};

const GRAPH_TYPES_TITLES = {
  [GAP]: { name: 'Law and practice scores' },
  [TABLE]: { name: 'RESOURCE GOVERNANCE TRENDS' },
  [BUBBLES]: { name: BUBBLES }
};

const LEGEND_VALUES = [
  { colorCode: '-good', description: '(>74)', value: 'Good' },
  { colorCode: '-satisfactory', description: '(60-74)', value: 'Satisfactory' },
  { colorCode: '-partial', description: '(45-59)', value: 'Weak' },
  { colorCode: '-weak', description: '(30-44)', value: 'Poor' },
  { colorCode: '-failing', description: '(<30)', value: 'Failing' },
  { colorCode: '-failing-v1', description: '', value: '2017 RGI Score',
    style: { marginLeft: '10px' }, mapOnly: true }
];

const SPECIAL_INSTITUTIONS_TABLE_LABELS = {
  '': {
    name: '',
    slug: 'general',
    ranks: {
      rank1: '(/74 SOEs)',
      rank2: {
        'oil-gas': '(/52 oil & gas SOEs)',
        mining: '(/22 mining SOEs)'
      }
    },
    nameLabel: 'Name of state-owned enterprise',
    valueLabel: 'Revenue (USD)',
    percentageLabel: 'State ownership level'
  },
  'Sovereign wealth fund governance': {
    name: 'Sovereign wealth fund governance',
    slug: 'sovereign',
    ranks: {
      rank1: '(/34)'
    },
    nameLabel: 'Name of Sovereign Wealth Fund',
    valueLabel: 'Value of assets under management (USD)'
  },
  'State-owned enterprise governance': {
    name: 'State-owned enterprise governance',
    slug: 'state-owned',
    ranks: {
      rank1: '(/74 SOEs)',
      rank2: {
        'oil-gas': '(/52 oil & gas SOEs)',
        mining: '(/22 mining SOEs)'
      }
    },
    nameLabel: 'Name of state-owned enterprise',
    valueLabel: 'Revenue (USD)',
    percentageLabel: 'State ownership level'
  }
};

export {
  composite, extraction, finance, environment, countriesRankData,
  rgi1, rgi2, rgi3, compare1, compare2, compare3, graph1, graph2, MAP_COUNTRY_FILLS,
  LEGEND_VALUES, GRAPH_TYPES, GRAPH_TYPES_TITLES, SPECIAL_INSTITUTIONS_TABLE_LABELS
};



// WEBPACK FOOTER //
// ./app/constants/countryProfile.js